module.exports = __webpack_public_path__ + "media/images/result_sets/icons/enneagram_icon_pdf-e8322393411df2262afb5c0b526f6d25.svg";